<template>
  <div class="chats">
    <!-- Show loading when getting data is in proccess -->
    <div class="text-center pb-12" v-if="pageLoading">
      <cube></cube>
      <span style="font-size: 16px">در حال بارگذاری ...</span>
    </div>
    <!-- Show page when data loaded -->
    <div v-else>
      <v-row class="ms-md-4 me-md-4 ms-0 me-0">
        <v-col cols="12">
          <!-- Chat list header -->
          <v-card class="chat-main list-header px-sm-4 px-2">
            <v-container>
              <v-row>
                <v-col sm="6" cols="12" class="py-sm-4 py-3 pe-0">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="blue-borderedBtn me-3"
                        style="min-width: 30px !important"
                        width="35"
                        v-bind="attrs"
                        v-on="on"
                        @click="getChats()"
                        ><v-icon>mdi-refresh</v-icon></v-btn
                      >
                    </template>
                    <span class="fs-xxsmall">بروزرسانی (Ctrl + R)</span>
                  </v-tooltip>
                  <!-- Chat list title -->
                  <span class="inbox-text fs-large">فهرست گفتمان</span>
                  <!-- Chat list badge to show the number of new messages -->
                  <v-badge
                    v-if="inboxNum"
                    color="primary"
                    :content="inboxNum + ' پیام جدید'"
                    style="transform: translateY(-3px)"
                  ></v-badge>
                </v-col>
                <!-- New chat button that it shows only for non-contact users and desktop screen -->
                <v-col
                  v-if="role != 'contact' && deviceType != 'mobile'"
                  class="text-left py-sm-4 py-3"
                >
                  <!-- New chat button when the user can chat Externally too -->
                  <v-btn
                    v-if="canChatExternally"
                    class="blue-borderedBtn"
                    @click="userTypeModal = true"
                    ><v-icon class="mt-1 me-2">$EditIcon</v-icon>
                    <span class="fs-xsmall">گفتگوی جدید</span>
                  </v-btn>
                  <!-- New chat button when the user can not chat Externally -->
                  <v-btn
                    v-else
                    class="blue-borderedBtn"
                    @click="
                      selectedUser = 'employee';
                      getEmployees();
                      openUsersModal('employee');
                    "
                    ><v-icon class="mt-1 me-2">$EditIcon</v-icon>
                    <span class="fs-xsmall">گفتگوی جدید</span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
          <v-card class="chat-main my-4 pa-sm-4 pa-0">
            <!-- New chat button that it shows only for mobile screen -->
            <div v-if="role != 'contact' && deviceType == 'mobile'">
              <!-- New chat button when the user can chat Externally too -->
              <v-btn
                v-if="canChatExternally"
                rounded
                class="new-btn primary"
                @click="userTypeModal = true"
                ><v-icon class="mt-1 me-2">$EditIcon</v-icon></v-btn
              >
              <!-- New chat button when the user can not chat Externally -->
              <v-btn
                v-else
                rounded
                class="new-btn primary"
                @click="
                  selectedUser = 'employee';
                  getEmployees();
                  openUsersModal('employee');
                "
                ><v-icon class="mt-1 me-2">$EditIcon</v-icon></v-btn
              >
            </div>
            <v-container>
              <!-- Chat list search field -->
              <div class="chats-search">
                <v-text-field
                  class="search-input mt-2"
                  placeholder="جستجو..."
                  outlined
                  rounded
                  dense
                  v-model="filter"
                >
                  <template #prepend-inner>
                    <v-icon> $Magnify </v-icon>
                  </template>
                  <template #append>
                    <span v-if="filter" @click="filter = ''">
                      <v-icon> mdi-close </v-icon></span
                    >
                  </template>
                </v-text-field>
              </div>
              <!-- The list of chats -->
              <div class="chats-list">
                <!-- Display when there is NO chat to show -->
                <div
                  class="text-center mt-8 dark-grey-color"
                  v-if="!filter && !computedChat.length"
                >
                  گفتگویی برای نمایش وجود ندارد.
                </div>
                <!-- Display when there is NO search result -->
                <div
                  class="text-center mt-8 dark-grey-color"
                  v-if="filter && !computedChat.length"
                >
                  نتیجه‌ای برای "{{ filter }}" یافت نشد!
                </div>
                <!-- Display when there is chat to show -->
                <div v-for="(item, index) in computedChat" :key="index">
                  <div
                    class="chat-box"
                    @click="openChat(item)"
                    :class="index != computedChat.length - 1 ? 'divider' : ''"
                  >
                    <div class="hover-box">
                      <v-row class="pe-md-3 ps-md-5 pe-0 ps-2">
                        <v-col cols="10" class="d-flex flex-row px-0">
                          <div class="image-box">
                            <v-gravatar
                              style="min-width: 55px"
                              :email="item.userEmail"
                            />
                          </div>
                          <div class="ms-4 mt-1">
                            <p class="senderName mb-2">{{ item.chatTitle }}</p>
                            <p
                              :dir="
                                messageDirection(item.lastMessage) == 'right' ||
                                !item.lastMessage ||
                                item.lastMessage.includes('blob')
                                  ? 'rtl'
                                  : 'ltr'
                              "
                              class="fs-xsmall grey--text mb-0 d-sm-block d-none"
                            >
                              <span
                                v-if="item.lastMessage.includes('blob')"
                                class="grey-icon"
                                style="margin-right: -5px"
                              >
                                <v-icon>$Record</v-icon>
                              </span>
                              {{
                                item.lastMessage
                                  ? !item.lastMessage.includes("blob")
                                    ? item.lastMessage.length > 70
                                      ? item.lastMessage.slice(0, 70) + "..."
                                      : item.lastMessage
                                    : "پیام صوتی"
                                  : "مکالمه‌ای برای نمایش وجود ندارد."
                              }}
                            </p>

                            <p
                              :dir="
                                messageDirection(item.lastMessage) == 'right' ||
                                !item.lastMessage ||
                                item.lastMessage.includes('blob')
                                  ? 'rtl'
                                  : 'ltr'
                              "
                              class="fs-xsmall grey--text mb-0 d-sm-none d-block"
                            >
                              <span
                                v-if="item.lastMessage.includes('blob')"
                                class="grey-icon"
                                ><v-icon>$Record</v-icon></span
                              >
                              {{
                                item.lastMessage
                                  ? !item.lastMessage.includes("blob")
                                    ? item.lastMessage.length > 20
                                      ? item.lastMessage.slice(0, 20) + "..."
                                      : item.lastMessage
                                    : "پیام صوتی"
                                  : "مکالمه‌ای وجود ندارد."
                              }}
                            </p>
                          </div>
                        </v-col>
                        <v-col class="fs-small text-left">
                          <div class="pt-2" style="position: relative">
                            <v-badge
                              v-if="item.unseenMessages != 0"
                              color="primary"
                              :content="
                                item.unseenMessages > 99
                                  ? '+99'
                                  : item.unseenMessages
                              "
                            >
                            </v-badge>

                            <div
                              class="badge"
                              v-if="item.unseenMessages == 0 && item.pinned"
                            >
                              <v-icon
                                color="primary"
                                small
                                style="transform: rotate(40deg)"
                                >mdi-pin</v-icon
                              >
                            </div>
                            <v-menu offset-y>
                              <template v-slot:activator="{ on, attrs }">
                                <span
                                  v-bind="attrs"
                                  v-on="on"
                                  style="margin-left: -10px"
                                  class="ms-1"
                                  ><v-icon style="transform: translateY(-2px)"
                                    >mdi-dots-vertical</v-icon
                                  ></span
                                >
                              </template>
                              <v-list class="py-0">
                                <v-list-item
                                  @click="togglePin(item)"
                                  :class="
                                    !item.pinned && !canPin
                                      ? 'disabled-box'
                                      : ''
                                  "
                                >
                                  <v-list-item-title
                                    ><v-icon
                                      class="pe-1"
                                      small
                                      style="transform: rotate(40deg)"
                                      >{{
                                        !item.pinned ? "mdi-pin" : "mdi-pin-off"
                                      }} </v-icon
                                    ><span
                                      class="fs-xsmall grey--text text--darken-2"
                                      >{{
                                        !item.pinned ? "نشان کردن" : "حذف نشان"
                                      }}</span
                                    ></v-list-item-title
                                  >
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </div>
                          <p
                            class="lastUpdate grey--text text-left d-flex fs-xsmall mt-1"
                          >
                            <span v-if="item.lastMessageSelf">
                              <v-icon
                                color="primary"
                                small
                                class="pe-2"
                                v-if="item.lastMessageSeen"
                                >mdi-check-all</v-icon
                              >
                              <v-icon color="primary" small class="pe-2" v-else
                                >mdi-check</v-icon
                              >
                            </span>
                            {{ item.messageDate }}
                          </p>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </div>
                <v-divider v-if="computedChat.length" class="my-0"></v-divider>
              </div>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
      <!-- The dialog to choose receiver type -->
      <v-dialog v-model="userTypeModal" width="500">
        <v-card class="newChat-modal-card">
          <v-container>
            <v-card-title class="pb-2 white">
              <v-row>
                <v-col cols="12" class="text-center">
                  <span class="dark-grey-color">انتخاب نوع مخاطب</span>
                </v-col>
              </v-row>
            </v-card-title>

            <hr class="mt-0" />
            <div class="text-center my-6">
              <span class="fs-medium mx-auto grey-color"
                >نوع مخاطب مورد نظر را انتخاب کنید:</span
              >
            </div>
            <div class="mt-9 mb-6">
              <v-row>
                <v-col class="text-md-left text-center">
                  <v-btn
                    @click="
                      openUsersModal('customer');
                      getAgents();
                    "
                    class="blue-mainBtn"
                    width="200"
                    height="50"
                    >نمایندگان مشتری</v-btn
                  >
                </v-col>
                <v-col class="text-md-right text-center">
                  <v-btn
                    @click="
                      openUsersModal('employee');
                      getEmployees();
                    "
                    class="blue-mainBtn"
                    width="200"
                    height="50"
                    >کارمندان</v-btn
                  >
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- The dialog to choose the receiver -->
      <v-dialog v-model="newChatModal" width="680">
        <v-card class="newChat-modal-card">
          <v-container>
            <v-card-title class="pt-2 white">
              <v-row>
                <v-col md="5" cols="12" class="pt-5">
                  <span class="dark-grey-color"
                    >انتخاب
                    {{
                      selectedUser == "customer" ? "نماینده" : "کارمند"
                    }}</span
                  >
                </v-col>
                <v-col class="px-2 pb-0">
                  <v-text-field
                    class="search-input"
                    placeholder="جستجوی نام کاربر..."
                    outlined
                    rounded
                    dense
                    @input="
                      selectedUser == 'customer'
                        ? (agentCurrentPage = 1)
                        : (employeeCurrentPage = 1)
                    "
                    v-model="contactSearch"
                  >
                    <template #prepend-inner>
                      <v-icon> $Magnify </v-icon>
                    </template>
                    <template #append>
                      <span
                        v-if="contactSearch"
                        class="pointer"
                        @click="contactSearch = ''"
                      >
                        <v-icon> mdi-close </v-icon>
                      </span>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </v-card-title>
            <div
              class="text-center pb-12"
              v-if="
                (selectedUser == 'customer' && gettingAgents) ||
                (selectedUser == 'employee' && gettingEmployees)
              "
            >
              <cube></cube>
              <span style="font-size: 16px">در حال بارگذاری ...</span>
            </div>
            <div v-else>
              <div
                class="text-center pt-6 pb-12"
                v-if="
                  (contactSearch &&
                    selectedUser == 'customer' &&
                    !computedAgent.length) ||
                  (contactSearch &&
                    selectedUser == 'employee' &&
                    !computedEmployee.length)
                "
              >
                نتیجه‌ای برای <b>"{{ contactSearch }}"</b> یافت نشد!
              </div>
              <v-card-text v-else>
                <div
                  class="contacts-list mt-2"
                  v-for="(item, index) in selectedUser == 'customer'
                    ? computedAgent
                    : computedEmployee"
                  :key="index"
                >
                  <div
                    class="contact-box d-flex flex-row pointer"
                    :class="
                      index != computedAgent.length - 1 ? 'border-bottom' : ''
                    "
                    @click="selectContact(item)"
                  >
                    <div class="image-box">
                      <v-gravatar style="min-width: 55px" :email="item.email" />
                    </div>
                    <div class="pa-4">
                      <span
                        v-if="selectedUser == 'employee'"
                        class="fs-small commonText--text"
                        >{{
                          item.name +
                          " " +
                          item.lastName +
                          " (" +
                          roles[item.role] +
                          ")"
                        }}</span
                      >
                      <span v-else class="fs-small commonText--text">{{
                        item.choiceName
                      }}</span>
                    </div>
                    <v-spacer></v-spacer>
                    <div class="pt-3" v-if="selectedContact[0] == item">
                      <v-icon color="primary" style="font-size: 1.7rem"
                        >mdi-checkbox-marked-circle</v-icon
                      >
                    </div>
                  </div>
                </div>
                <div
                  v-if="
                    (selectedUser == 'customer' && computedAgent.length) ||
                    (selectedUser == 'employee' && computedEmployee.length)
                  "
                  class="blue-custom-pagination mt-6"
                >
                  <v-pagination
                    v-if="selectedUser == 'customer'"
                    v-model="agentCurrentPage"
                    :length="
                      Math.ceil(
                        agents.filter((x) =>
                          x.choiceName.includes(contactSearch)
                        ).length / perPage
                      )
                    "
                    :total-visible="5"
                  ></v-pagination>

                  <v-pagination
                    v-else
                    v-model="employeeCurrentPage"
                    :length="
                      Math.ceil(
                        employees.filter((x) => x.name.includes(contactSearch))
                          .length / perPage
                      )
                    "
                    :total-visible="5"
                  ></v-pagination>
                </div>
                <v-row class="mt-sm-6 mt-3">
                  <v-col class="text-md-right text-center pb-0">
                    <v-btn
                      @click="newChatModal = false"
                      class="blue-borderedBtn"
                      :width="deviceType != 'mobile' ? 200 : 105"
                      :height="deviceType != 'mobile' ? 50 : 40"
                    >
                      بستن
                    </v-btn>
                  </v-col>

                  <v-col class="text-md-left text-center pb-0">
                    <v-btn
                      :disabled="!selectedContact.length"
                      class="blue-mainBtn"
                      :width="deviceType != 'mobile' ? 200 : 105"
                      :height="deviceType != 'mobile' ? 50 : 40"
                      @click="addNewChat()"
                    >
                      شروع گفتمان
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </div>
          </v-container>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import Axios from "axios";
export default {
  data() {
    return {
      // STRING variables
      role: "",
      filter: "",
      deviceType: "",
      selectedUser: "",
      contactSearch: "",
      // NUMBER variables
      perPage: 4,
      inboxNum: 0,
      agentCurrentPage: 1,
      employeeCurrentPage: 1,
      // ARRAY variables
      chats: [],
      agents: [],
      employees: [],
      selectedContact: [],
      // BOOLEAN variables
      guide: false,
      pageLoading: false,
      newChatModal: false,
      userTypeModal: false,
      gettingAgents: false,
      gettingEmployees: false,
      canChatExternally: false,
      // OBJECT variables
      roles: {
        Manager: "مدیر",
        ceo: "مدیرعامل",
        secretary: "منشی",
        trade: "کارشناس بازرگانی",
        tradeIntern: "کارآموز بازرگانی",
        tradeHead: "کارشناس فنی",
        queryOrganizer: "بازرس سفارشات",
        accountant: "حسابدار",
        salesManager: "مدیر فروش",
        factory: "مدیر کارخانه",
        factoryTechnical: "مسئول فنی کارخانه",
        qa: "QA & DCC",
        qc: "مدیر کنترل کیفیت و آزمایشگاه",
        qcAgent: "کنترل کیفی",
        qcDocument: "سرتیفیکیت",
        factoryPacking: "مسئول پکینگ",
        production: "مدیر خط تولید",
        delivery: "دلیوری",
        coldForgingSupervisor: "سرپرست فورج سرد",
        cuttingNutSupervisor: "مهره‌تراش",
        coatingSupervisor: "داک و پوشش",
        threadingSupervisor: "سرپرست رزوه زنی",
        machiningSupervisor: "سرپرست ماشین کاری و فرزکاری",
        cncSupervisor: "سرپرست CNC",
        knittingSupervisor: "سرپرست قلاویز زنی و مهره تراشی",
        weldingSupervisor: "سرپرست جوشکاری",
        heatTreatmentSupervisor: "سرپرست عملیات حرارتی و سیاه کاری",
        hotForgingSupervisor: "سرپرست فورج گرم",
        dichromateSupervisor: "سرپرست داکرومات",
        cuttingSupervisor: "سرپرست برشکاری",
        factoryGeneral: "کارمند کارخانه",
        warehouse: "مسئول کل انبار",
        productsWarehouse: "مسئول انبار محصولات",
        materialsWarehouse: "مسئول انبار مواد اولیه",
        toolsWarehouse: "مسئول انبار ملزومات",
        shop: "مسئول فروشگاه",
      },
    };
  },
  methods: {
    // the function to show and hide guide dialog
    toggleHelp() {
      this.guide = !this.guide;
    },
    // the function to open dialog of users width desired type
    openUsersModal(type) {
      this.userTypeModal = false;
      this.selectedUser = type;
      this.newChatModal = true;
    },
    // the function to open desired chat room
    openChat(item) {
      localStorage.setItem("chatUserId", item.chatUserId);
      this.$router.push("/chat/" + item.chatId);
    },

    // the function to toggle message pin
    togglePin(item) {
      Axios.post(
        this.baseUrl +
          "/ppkpms" +
          (this.role == "contact" ? "/contact" : "/user") +
          "/pin/" +
          item.chatId,
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.chats = res.data.chats;
            this.inboxNum = res.data.unseenMessages;
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast("Error: " + err.response.data, "error");
        });
    },
    // the function to create a new chat room width selected user
    addNewChat() {
      if (this.selectedUser == "customer") {
        Axios.post(
          this.baseUrl + "/ppkpms/chat/newExternal",
          {
            contactId: this.selectedContact[0].id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
          .then((res) => {
            if (res.status == 200) {
              this.$router.push("/chat/" + res.data.chatId);
              localStorage.setItem("chatUserId", res.data.chatUserId);
            } else {
              this.toast(res.data, "error");
            }
          })
          .catch((err) => {
            this.toast("Error: " + err.response.data, "error");
          });
      } else {
        Axios.post(
          this.baseUrl + "/ppkpms/chat/newInternal",
          {
            userId: this.selectedContact[0].id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
          .then((res) => {
            if (res.status == 200) {
              localStorage.setItem("chatUserId", res.data.chatUserId);
              this.$router.push("/chat/" + res.data.chatId);
            } else {
              this.toast(res.data, "error");
            }
          })
          .catch((err) => {
            this.toast("Error: " + err.response.data, "error");
          });
      }
    },
    // the function to get all built-in chats
    getChats() {
      this.pageLoading = true;
      Axios.get(
        this.baseUrl +
          "/ppkpms" +
          (this.role == "contact" ? "/contact" : "") +
          "/chats/list",

        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.chats = res.data.chats;
            this.inboxNum = res.data.unseenMessages;
            this.pageLoading = false;
          } else {
            this.toast("Error: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
            this.pageLoading = false;
          }
        })
        .catch((err) => {
          this.toast("Error: " + err.response.data, "error");
          this.pageLoading = false;
        });
    },
    // the function to get AGENT users
    getAgents() {
      this.gettingAgents = true;
      Axios.get(this.baseUrl + "/ppkpms/chat/requirements/allContacts", {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("token"),
        },
      })
        .then((res) => {
          this.agents = res.data;
          this.gettingAgents = false;
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.gettingAgents = false;
        });
    },
    // the function to get EMPLOYEE users
    getEmployees() {
      this.gettingEmployees = true;
      Axios.get(this.baseUrl + "/ppkpms/chat/requirements/allUsers", {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("token"),
        },
      })
        .then((res) => {
          this.employees = res.data;
          this.gettingEmployees = false;
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.gettingEmployees = false;
        });
    },
    // the function to select user as chat receiver
    selectContact(item) {
      if (this.selectedContact[0] == item) {
        this.selectedContact = [];
      } else {
        if (!this.selectedContact.length) {
          this.selectedContact.push(item);
        } else {
          this.selectedContact = [];
          this.selectedContact.push(item);
        }
      }
    },
    // the function to detect message text direction
    messageDirection(value) {
      var rtl_rx = /[\u0591-\u07FF]/;
      return rtl_rx.test(value) ? "right" : "left";
    },
  },
  computed: {
    computedChat() {
      let chats = this.chats;
      let filtered;
      if (this.filter) {
        chats.forEach((x) => {
          x.chatTitle = x.chatTitle.toLowerCase();
        });
        let filter = this.filter.toLowerCase();
        filtered = chats.filter((x) => x.chatTitle.includes(filter));
      } else {
        filtered = chats;
      }

      return filtered;
    },
    computedAgent() {
      let agents = this.agents;
      let filtered;

      if (this.contactSearch) {
        let search = this.contactSearch.toLowerCase();
        filtered = agents.filter((x) =>
          x.choiceName.toLowerCase().includes(search)
        );
      } else {
        filtered = this.agents;
      }

      filtered = filtered.slice(
        4 * (this.agentCurrentPage - 1),
        4 * this.agentCurrentPage
      );

      return filtered;
    },
    computedEmployee() {
      let employees = this.employees;
      let filtered;

      if (this.contactSearch) {
        let search = this.contactSearch.toLowerCase();
        filtered = employees.filter((x) =>
          x.name.toLowerCase().includes(search)
        );
      } else {
        filtered = this.employees;
      }

      filtered = filtered.slice(
        4 * (this.employeeCurrentPage - 1),
        4 * this.employeeCurrentPage
      );

      return filtered;
    },
    canPin() {
      let pinnedMessages = [];
      pinnedMessages = this.chats.filter((x) => x.pinned);
      if (pinnedMessages.length < 3) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    // Get the user role
    this.role = localStorage.getItem("role");
    // Get user access
    if (this.role != "contact") {
      this.canChatExternally = JSON.parse(localStorage.canChatExternally);
    }
    // To detect the device type
    if (window.screen.width < 768) {
      this.deviceType = "mobile";
    } else if (window.screen.width > 768 && window.screen.width < 1024) {
      this.deviceType = "tablet";
    }

    this.getChats();
  },
};
</script>
<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
.new-btn {
  border-radius: 50px;
  width: 50px !important;
  min-width: 51px !important;
  height: 50px !important;
  position: absolute;
  bottom: 15px;
  left: 12px;
  z-index: 100;
  path {
    stroke: #fff !important;
  }
  svg {
    transform: translateX(-2px);
  }
}
.v-dialog,
.adding-modal-card {
  border-radius: 20px !important;
  @media only screen and (max-width: 600px) {
    max-height: 500px;
    overflow-y: auto;
  }
  .v-text-field--outlined fieldset {
    border-color: #ccc !important;
  }

  .projects-box,
  .tasks-box {
    max-height: 210px;
    min-height: 100px;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
    .project-box,
    .task-box {
      margin-top: 25px;
      border-radius: 7px;
      max-height: 100px;
      .flagImage-box {
        width: 33px;
        height: 23px;

        .v-image {
          width: 100%;
          height: 100%;
          border-radius: 2px;
        }
      }
    }
    .selected-box {
      background-color: #e8f5f9 !important;
      border: 1px solid #0090b8 !important;
      color: #0090b8 !important;
    }
  }
  .v-text-field.v-text-field--enclosed .v-text-field__details {
    display: none;
  }
}
.v-dialog,
.newChat-modal-card {
  border-radius: 20px !important;
  @media only screen and (max-width: 600px) {
    max-height: 500px;
    overflow-y: auto;
  }
  .v-text-field--outlined fieldset {
    border-color: #ccc !important;
  }
  .contacts-list {
    .contact-box {
      padding: 5px 0 10px !important;
      .image-box {
        width: 53px;
        height: 53px;
        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
      &.border-bottom {
        border-bottom: 1px solid #ccc;
      }
    }
  }
}
</style>
